import lrDraggable from './_src/lrDraggable.vue'

lrDraggable.install = function(Vue) {
  Vue.component(lrDraggable.name, lrDraggable)
}

export default lrDraggable